import React, { Component } from 'react'
import { Card, Elevation, Spinner } from '@blueprintjs/core'

import moment from 'moment'
import _ from 'lodash'
import numeral from 'numeral'
import SimpleBar from 'simplebar-react'

import axios from '../../../services/axios'
import storage from '../../../services/storage'

import Loads, { createLoader } from 'react-loads'
import Loading from '../../Shared/LoadingCharts'
import Title from '../../Shared/TitleChart'
import Reload from '../../Shared/ReloadChart'
import Error from '../../Shared/ErrorChart'
import './styles.css'

class Labels extends Component {
  constructor(props){
    super(props)

    this.state = {
      data: []
    }

    this.reload = 0
    this.success = this.success.bind(this)
    this.error = this.error.bind(this)
    this.loading = this.loading.bind(this)

    this.chart = this.chart.bind(this)
    this.getData = this.getData.bind(this)
  }

  getData(range){
    const { competitor } = this.props
    const since = moment(range[0]).format('YYYY-MM-DD')
    const until = moment(range[1]).format('YYYY-MM-DD')
    
    return storage.get('page')
    .then((page)=>{
      return axios.get(`${competitor == 'brand' ? 'social' : 'competitionsocial'}/vision/${page}/labels?top=15&since=${since}&until=${until}`)
    })
  }

  body(data){
    return (
      <SimpleBar style={{maxHeight: '366px', width: '100%'}}>
        <tbody>
          {data.map((object, index)=>{
            return (
              <tr>
                <td>{index+1}. {object.name}</td>
                <td>{numeral(object.score).format('0,0.00')}%</td> 
              </tr>
            )
          })}
          {_.range(0, 15 - data.length, 1).map((object, index)=>{
            return (
              <tr>
                <td>-</td>
                <td>-</td> 
              </tr>
            )
          })}
        </tbody>
      </SimpleBar>
    )
  }

  chart(data){
	  return (
			<div className="socialLabelsItems">
				<div className="socialLabelsItem">
				  <table>
				    <thead>
				      <tr>
				        <th>Objects</th>
				        <th>ER</th> 
				      </tr>
				    </thead>
				    {this.body(data.slice(0, 30))}
				  </table>
				</div>
			</div>
	  )
  }

  success({ response, load }){
    const data = response.data.data
    const Chart = this.chart(data)

    return (
      <div>
        {Chart}
      </div>
    )
  }

  error({ error, load }){
    switch(true){
      case this.reload < 6:
        this.reload++
        load()
        return (<Loading />)
      break

      case this.reload < 10:
        return (<Reload onReload={()=>{
          this.reload++
          load()
        }} />)
      break

      case this.reload > 9:
        return (<Error 
          error={error.message} 
        />)
      break
    }
  }

  shouldComponentUpdate(props){
    return !_.isEqual(this.props, props)
  }

  loading(){
    return (
      <Loading />
    )
  }

  render() {
    const Chart = createLoader({
      load: () => this.getData(this.props.range)
    })

    return (
      <Card 
        interactive={false} 
        elevation={Elevation.TWO} 
        className="no-pad-t-b"
        id="socialLabels">
        <Title title='Labels' />
         <div className='socialLabelsContainer'>
          <Chart loadOnMount>
            <Chart.Loading>
              {this.loading()}
            </Chart.Loading>
            <Chart.Success>
              {this.success}
            </Chart.Success>
            <Chart.Error>
              {this.error}
            </Chart.Error>
          </Chart>
        </div>
      </Card>
    )
  }
}

export default Labels



// WEBPACK FOOTER //
// ./src/components/SocialIntelligence/Labels/index.js